import { FlagsConstants, getAppLogger } from '@tgg/util';

export const appConfig = {
    appIdentifier: FlagsConstants.UNRESOLVED as const,
    appLogger: getAppLogger({
        applicationIdentifier: FlagsConstants.UNRESOLVED,
    }),
};
